// extracted by mini-css-extract-plugin
module.exports = {"PrivacyPolicy":"PrivacyPolicy_PrivacyPolicy__35fE- index_caption__1AJ2W"};